import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import { authAxiosInstance } from '@cheetahdigital/cesauth-core-lib';

var getApps = function (baseURL) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, authAxiosInstance.get("/app/listing?is_login_as=true", {
                    baseURL: baseURL
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };

export { getApps };
